module.exports = __webpack_public_path__ + "static/assets/41dfa445485f7a81540bded1568a600f.png";